import { Component, input } from '@angular/core';

import { SafeHtmlPipe } from '@shared/pipes';

export interface FaqItem {
  question: string;
  answer: string;
}

@Component({
  selector: 'app-faq',
  imports: [SafeHtmlPipe],
  templateUrl: './faq.html',
  styleUrl: './faq.scss',
})
export class Faq {
  readonly title = input('Answers to Your Questions');
  readonly faqs = input<FaqItem[]>([]);
  readonly note = input('');

  openedIndex: number | null = null;

  toggleAccordion(index: number): void {
    this.openedIndex = this.openedIndex === index ? null : index;
  }
}
